<script lang="ts" setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { McoStayEdition } from '@/maintenance/types'
import { ValidationTypeEnum } from '@/store/modules/stay/types'

const { t } = useI18n()

const props = defineProps<{
  stayEdition: McoStayEdition
}>()

const automationLabelKeys: Partial<Record<ValidationTypeEnum, string>> = {
  [ValidationTypeEnum.AUTOMATION_AI]: 'stayEdition.validatedByAutomationAi',
  [ValidationTypeEnum.AUTOMATION_RULES]: 'stayEdition.validatedByAutomationRules',
  [ValidationTypeEnum.RECONDUCTION]: 'stayEdition.validatedByReconduction',
}

const author = computed<string>(() => {
  const labelKey = props.stayEdition.validationType
    ? automationLabelKeys[props.stayEdition.validationType]
    : undefined

  if (labelKey) {
    return t(labelKey, { group: props.stayEdition.validatedGroupName })
  }

  return props.stayEdition.username
})

</script>

<template>
  <tr>
    <td>{{ stayEdition.creationDate.format('DD/MM/YYYY à HH:mm:ss') }}</td>
    <td>{{ t("stayEdition.type."+stayEdition.type, stayEdition.type) }}</td>
    <td>{{ stayEdition.target }}</td>
    <td>{{ t("stayEdition.mode."+stayEdition.mode, stayEdition.mode) }}</td>
    <td>{{ author }}</td>
    <td>{{ stayEdition.ghm }}</td>
    <td>{{ stayEdition.value }}</td>
  </tr>
</template>
